import styled from 'styled-components'
import withRenderModal from 'hocs/withRenderModal'

import MainModal from 'modals/MainModal'

import { useModal } from 'hooks'
import TypographyPrimary from 'components/Typography/Primary'
import { StyledBody } from 'pages/Subnets/panels/ApiPanel/CreateSubnetApiKeyModal'

const EmailSentModal = () => {
    const { closeModal } = useModal()

    const handleCloseModal = () => {
        closeModal('email-sent')
    }

    return (
        <MainModal onClose={handleCloseModal} title={''} customButtons={<></>}>
            <StyledBody>
                <TypographyPrimary
                    value={`We've sent you an email with a link to reset your password. Please check your
                    inbox (or spam folder) for further instructions.`}
                    size={'small'}
                />
            </StyledBody>
        </MainModal>
    )
}

export default withRenderModal('email-sent')(EmailSentModal)
